import { connect } from 'react-redux';

// TODO: Fix dependency cycle - SAAS-992
// eslint-disable-next-line import/no-cycle
import JSX from '../Page';

const mapStateToProps = (state) => ({
    session: state.session,
    tenants: state.tenants
});

export default connect(mapStateToProps, null)(JSX);
